import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-19666
 * Тулбар в порталке для AI-тарифа
 */
export const AI_TARIFF_TOOLBAR_TOOLTIP_ENABLED = getFeature('ai-tariff-toolbar-tooltip-variant');

// id РБ-кампаний тултипов для АИ-тарифа
export const AI_TARIFF_TOOLBAR_TOOLTIP_CAMPAIGN_IDS = getFeature('ai-tariff-toolbar-tooltip-campaigns-ids') || ['118945498', '118945499'];

// тариф
export const AI_TARIFF_TOOLBAR_TOOLTIP_PRODUCT_ID =
    getFeature('ai-tariff-toolbar-tooltip-product-id') || 'W256GB_1m_letter_style_discount_force_trial';

// фичи
export const AI_TARIFF_TOOLBAR_TOOLTIP_FEATURES_ID = getFeature('ai-tariff-toolbar-tooltip-features-id') || '9';

// заголовок для фастчекаута
export const AI_TARIFF_TOOLBAR_TOOLTIP_BUY_TITLE =
    getFeature('ai-tariff-toolbar-tooltip-buy-title') || 'Подписка Mail Space с нейросетью на месяц бесплатно';
